<template>
  <div class="fluid-container p-1 p-lg-0 header"> 
      <b-row class="p-0  mb-5  col-lg-8 m-auto">
      <div class=" p-0 mb-3 col-md-8"> 
          <h1>{{performance.name}}</h1>        
          <h4>{{performance.location}}</h4>         
          {{performance.date}}
          <div class="noprint bg-info text-white border rounded shadow  m-auto  p-1 row">
              <div class="col-6 font-weight-bold">Total Orders: {{TotalOrders}}</div>
              <div>
                <em v-for="group in grouped_totals" :key="group" class = "ml-2 badge text-white bg-secondary border rounded shadow">
                        {{ group.type }}: {{ group.total }} 
                </em>
              </div>
              <div class="col-6 font-weight-bold float-right"> Minimum Order QTY: {{performance.moq}}</div>
          </div>
      </div>
   
      <div v-if="logo_url" class="col-4 col-md-4 pimg">
          <b-img  right class="d-none d-md-inline"  :src="logo_url"/>         
      </div>
      
      </b-row>
  </div>
  </template>
  
  <script>
  /* eslint-disable */ 
    export default {
      name: "Performance",
      data() {
        return {
          performance: '' ,
          numOrder: '',
          logo_url: '',
          grouped_totals: ''
          }   
      },
      props: {
        authenticated: {},
        admin: {}
      }, 
      methods: {
        LoadPerformance() {
          let currentObj = this;
          this.axios.get('https://www.aperturefilms.com.au/customer-portal/performance.php')
                  .then(function (response) {
                      currentObj.performance = response.data[1][0]
                      currentObj.logo_url = currentObj.performance.logo_url 
                      currentObj.numOrder = response.data[0][0].TotalQty
  
                  })
                  .catch(function (error) {
                      console.log(error);  
                  });
        },
        LoadTotals() {
          let currentObj = this;
          let params = new URLSearchParams();
              params.append('task', 'countTotals');
              this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                  .then(function (response) {
                      if (response.data) {
                          currentObj.grouped_totals = response.data
                          console.log(currentObj.grouped_totals)
  
                      }
  
                  })
                  .catch(function (error) {
                      console.log(error);  
                  });
        }
      },
      created() {
          this.LoadPerformance()
          this.LoadTotals()
      },
      computed: {
        TotalOrders: function () {
          var nt = this.numOrder
          if (!nt) nt = '0'
          return nt
    }
  }
    }
  </script>
  <style scoped>
  .fluid-container {
       margin-top: 90px;
  
  }
  img {
    max-width: 200px;
    max-height: 160px;
  }
  
  
  @page {
    @top-center {
      content: element(header);
    }
  }
  #pageHeader{
    position: running(header);
  }
  
  
  @media print {
    .header {
      position: fixed;
      width:170mm;
      top:0;
  
      
    }
    .pimg {
      float:right;
    }	
    .noprint {
      display:none;
    }
      
    }
  </style>